import { render, staticRenderFns } from "./ExportProductInformation.vue?vue&type=template&id=4ed2bb1c&scoped=true"
import script from "./ExportProductInformation.vue?vue&type=script&lang=js"
export * from "./ExportProductInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2bb1c",
  null
  
)

export default component.exports